import { createResource } from "redux-rest-resource";
import { setAuthHeader, getAuthData } from "../../helpers/authStorage";

import { API_URL } from "../../constants/config";

export const { types, actions, rootReducer } = createResource({
  name: "tenants",

  actions: {
    get: {
      method: "GET",
      url: `${API_URL}/tenants`,
    },
  },
});

setAuthHeader(getAuthData().accessToken);
